import { useUserInfo } from "@/contexts/userInfoContext";
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import { AiOutlineCheck } from "react-icons/ai";
import { useParams, useNavigate } from "react-router-dom";
import Caroussel from "@/components/Caroussel/Caroussel";
import { useEffect, useState } from "react";

import Zipdin1 from "/src/assets/Zipdin/1.png";
import Zipdin2 from "/src/assets/Zipdin/2.png";
import Zipdin3 from "/src/assets/Zipdin/3.png";
import Zipdin4 from "/src/assets/Zipdin/4.png";
import Zipdin5 from "/src/assets/Zipdin/5.png";
import Zipdin6 from "/src/assets/Zipdin/6.png";
import Zipdin7 from "/src/assets/Zipdin/7.png";
import Zipdin8 from "/src/assets/Zipdin/8.png";
import Zipdin9 from "/src/assets/Zipdin/9.png";
import Zipdin10 from "/src/assets/Zipdin/10.png";
import Zipdin11 from "/src/assets/Zipdin/11.png";

import QI1 from "/src/assets/QI/1.png";
import QI2 from "/src/assets/QI/2.png";
import QI3 from "/src/assets/QI/3.png";
import QI4 from "/src/assets/QI/4.png";
import QI5 from "/src/assets/QI/5.png";
import QI6 from "/src/assets/QI/6.png";
import QI7 from "/src/assets/QI/7.png";
import QI8 from "/src/assets/QI/8.png";
import QI9 from "/src/assets/QI/9.png";
import QI10 from "/src/assets/QI/10.png";
import QI11 from "/src/assets/QI/11.png";
import { useSlug } from "@/contexts/selfServiceSlugContext";

export default function FGTSTutorial() {
  const { user } = useUserInfo();
  const { slug, slugSeller, slugSelfService } = useParams<{
    slug?: string;
    slugSeller?: string;
    slugSelfService?: string;
  }>();
  const [imagesBank, setImagesBank] = useState<string[]>([]);
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(true);
  const { selfServiceSlug } = useSlug();
  const whatsappNumber = selfServiceSlug?.supportPhone;
  const processorName = selfServiceSlug?.product?.processor?.name;
  const isZipdin = processorName === "ZIPDIN";
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [countdown, setCountdown] = useState<number>(5);

  const navigate = useNavigate();

  const handleSupport = () => {
    let phoneNumber = "+55" + whatsappNumber?.replace(/\D/g, "");

    const message =
      "Olá, estou tentando antecipar meu saque aniversário e tenho uma dúvida!";
    const whatsappURL = `https://wa.me/${phoneNumber}/?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  const handleDownload = (platform: "ios" | "android") => {
    if (platform === "ios") {
      window.open("https://apps.apple.com/br/app/id1038441027", "_blank");
    } else {
      window.open(
        "https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador",
        "_blank"
      );
    }
  };

  const getImages = () => {
    if (isZipdin) {
      setImagesBank([
        Zipdin1,
        Zipdin2,
        Zipdin3,
        Zipdin4,
        Zipdin5,
        Zipdin6,
        Zipdin7,
        Zipdin8,
        Zipdin9,
        Zipdin10,
        Zipdin11,
      ]);
    } else {
      setImagesBank([QI1, QI2, QI3, QI4, QI5, QI6, QI7, QI8, QI9, QI10, QI11]);
    }
  };

  useEffect(() => {
    getImages();
  }, [processorName]);

  const authorizationTexts = isZipdin
    ? ["ZIPDIN SOLUÇÕES DIGITAIS SOCIEDADE DE CREDITO DIRETO S/A"]
    : [
        "ZIPDIN SOLUÇÕES DIGITAIS SOCIEDADE DE CREDITO DIRETO S/A",
        "QI SOCIEDADE DE CREDITO DIRETO S.A",
      ];

  const modalMessage = isZipdin
    ? "Você já aprovou a bancarizadora ZIPDIN?"
    : "Você já autorizou as seguintes bancarizadoras? ZIPDIN e QI Tech?";

  const proceed = () => {
    navigate(
      slugSelfService
        ? `/${slug}/${slugSeller}/${slugSelfService}/loading`
        : slugSeller
        ? `/${slug}/${slugSeller}/loading`
        : `/${slug}/loading`
    );
  };

  useEffect(() => {
    if (isOpen) {
      setCountdown(5);
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) clearInterval(interval);
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isOpen]);

  return (
    <>
      <Flex w="100%" bg="gray.100" justifyContent="center">
        <Flex
          py="2rem"
          px={{ base: "1rem", lg: "2rem" }}
          minHeight="100vh"
          w="100%"
          maxW="450px"
          color="gray.600"
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          flexDirection="column"
        >
          <Flex
            fontSize="sm"
            alignItems="center"
            textAlign="center"
            flexDirection="column"
            gap={4}
          >
            <Flex justifyContent="flex-end" w="95%">
              <Button
                onClick={handleSupport}
                size="sm"
                variant="outline"
                leftIcon={<FaWhatsapp size={16} />}
                color="primary"
                bg="white"
                _hover={{ bg: "white", color: "primary" }}
              >
                Suporte
              </Button>
            </Flex>
            <Text>
              Olá <strong>{user.name?.split(" ")[0]}</strong>, antes de
              iniciarmos sua simulação, precisamos seguir alguns passos, vamos
              lá?
            </Text>
            <Text>
              {isZipdin
                ? "Autorize nosso parceiro"
                : "Autorize nossos parceiros"}
            </Text>

            {authorizationTexts.map((text: string, index: number) => (
              <Heading key={index} fontSize="sm" color="secondary">
                "{text}"
              </Heading>
            ))}

            <Text>No seu aplicativo do FGTS.</Text>
            <Text fontWeight={"extrabold"}>Veja o passo a passo abaixo.</Text>
          </Flex>

          <Caroussel imagens={imagesBank} setIsBtnDisabled={setIsBtnDisabled} />

          <Box w="100%">
            <Button
              w={"100%"}
              bg="primary"
              color="white"
              fontFamily="Lexend Deca"
              onClick={onOpen}
              pr={2}
              disabled={isBtnDisabled}
            >
              Já autorizei
              <Icon as={AiOutlineCheck} ml={2} boxSize={4} color="white" />
            </Button>
            <Flex mt={2} gap={2} mb={8}>
              <Button
                w={"100%"}
                bg="gray.50"
                border={"gray solid 1px"}
                color="gray.700"
                fontFamily="Lexend Deca"
                pr={2}
                fontWeight={400}
                onClick={() => handleDownload("android")}
              >
                Baixe na PlayStore
              </Button>
              <Button
                w={"100%"}
                bg="gray.50"
                border={"gray solid 1px"}
                color="gray.700"
                fontFamily="Lexend Deca"
                onClick={() => handleDownload("ios")}
                pr={2}
                fontWeight={400}
              >
                Baixe na App Store
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xs">
        <ModalOverlay />
        <ModalContent
          borderRadius="2xl"
          px={4}
          py={6}
          bg="white"
          fontFamily="Lexend Deca"
          boxShadow="lg"
        >
          <ModalHeader
            fontSize="lg"
            fontWeight="bold"
            textAlign="center"
            color="gray.700"
            px={0}
            pt={0}
            mt={8}
          >
            Aprovação de bancarizadora
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pt={2} px={0}>
            <Text fontSize="md" textAlign="center" color="gray.600">
              {modalMessage}
            </Text>
          </ModalBody>
          <ModalFooter
            display="flex"
            justifyContent="center"
            gap={3}
            flexDirection="row"
            px={0}
            pt={6}
          >
            <Button
              bg="#E53E3E"
              color="white"
              _hover={{ bg: "#F56565" }}
              onClick={onClose}
              borderRadius="lg"
              fontSize="sm"
              px={6}
              py={5}
              fontWeight={500}
            >
              Não
            </Button>
            <Button
              bg="#48BB78"
              color="white"
              _hover={{ bg: "#6CC893" }}
              onClick={proceed}
              isDisabled={countdown > 0}
              borderRadius="lg"
              fontSize="sm"
              px={6}
              py={5}
              fontWeight={500}
            >
              {countdown > 0 ? `Sim (${countdown})` : "Sim"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
